export default "__VITE_ASSET__UYOgBYE$__";